import jMoment from 'moment-jalaali';
import { INSTALLMENT_STATUS_CODE } from '../../../constants/Options';
import { PriceLabel } from 'components';

const columns = (actionsList, ActionBtn , currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: `مبلغ (${currencyText})`,
    field: 'amount',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => <PriceLabel amount={rd.amount} />
  },
  {
    title: 'تاریخ سررسید',
    field: 'dueDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => (rd?.dueDate && rd?.dueDate != 0 && rd?.dueDate != '0') ? jMoment(rd?.dueDate).format('jYYYY/jMM/jD') : '-',
  },
  {
    title: 'وضعیت',
    field: 'status',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => INSTALLMENT_STATUS_CODE.find((s) => s.value === rd.status)?.label ?? '-',
  },

  ...((actionsList['loanPayPayAction']) ? [{
    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <ActionBtn rd={rowData} />
    ),
  }] : []),
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
